import React  from 'react';
import { useSelector } from "react-redux";
import Modal from '../modals/Modal';
import { api } from '../../api';



import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import $ from "jquery";

const KeyModal = (props) => {
const { showModal, closeModal, transactionId, quantity, listData } = props
const token = useSelector((state) => state.auth.token);
// var data =  listData.length >= 0 ? listData : []

let columns=[
    { title: "Product Key", data: "productkey" },
    // { title: "productkeyId", data: "productkeyId" },
    { title: "Used", data: "used" }
  ]

listData.length && $('#example').DataTable( {
    data: listData,
    columns: columns
} );

const handleClick = _ => {
    // console.log(transactionId, ' iddd')
    // console.log(quantity, ' quantity')
    api.products.getTransactionListById({ transactionId, pageSize: quantity, pageNo: '1' },token)
        .then(res => {
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            // eslint-disable-next-line
            const fileExtension = '.xlsx';
            
            const ws = XLSX.utils.json_to_sheet(res.data);
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, "ProductKey.xlsx");    
        })
        // .then(res => console.log(res, ' ress'))
}
  return (
    <Modal
      id="KeyModal"
      showModal={showModal}
      closeModal={closeModal}
      modalHeader="PRODUCTS KEY"
      showExport={ true }
      >
    <div>
        <i className="bx bx-menu bold dropdown-toggle p-2" style={{ position: 'absolute', top: '15px', right: '15px', cursor: 'pointer' }} data-toggle="dropdown"></i>
        <div className="dropdown-menu dropdown-list1" style={{ cursor: 'pointer'}}>
             <span className="dropdown-item" onClick={handleClick}>
                <i className="bx bxs-file-pdf mr-2"></i>Export Keys
             </span>
        </div>
    </div>
        <table id="example" className="display table table-striped table-bordered" width="100%" style={{ textAlign: 'center'}}></table>
    </Modal >
  );
}

export default KeyModal;